// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__UT5cj","loading":"Loading_loading__7Zdc5"};